import {
  CCol,
  CFormInput,
  CFormLabel,
  CLoadingButton,
  CRow,
} from "@coreui/react-pro";
import { useState } from "react";
import axios from "@/shared/config/axios-interceptor";
import { ToastInfo, ToastSuccess } from "@/components/shared/toast/Toast";
import Header from "../components/Header";
import Footer from "../components/Footer";

const ThayDoiMatKhau = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const onSubmit = async () => {
    if (!currentPassword || !newPassword || !confirmNewPassword) {
      ToastInfo("Vui lòng nhập đầy đủ thông tin!");
      return;
    }
    try {
      setLoading(true);
      const res = await axios.put("/auth/change-password", {
        currentPassword,
        newPassword,
        confirmNewPassword,
      });
      ToastSuccess("Đổi mật khẩu thành công!");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  return (
    <div className="wrapper">
      <div className="container-web bgnew bank">
        <Header title="Đổi mật khẩu" />

        <div className="p-3 custom-form">
          <CRow className="g-3">
            <CCol xs={12}>
              <CFormLabel
                style={{ color: "#deaa4f" }}
                className="mb-6 label-gray-700 text-sm"
              >
                Mật khẩu hiện tại
              </CFormLabel>
              <CFormInput
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                style={{
                  background: "transparent",
                  color: "#fff",
                  borderColor: "#deaa4f",
                }}
                className="form-height-44 w-100"
              />
            </CCol>

            <CCol xs={12}>
              <CFormLabel
                style={{ color: "#deaa4f" }}
                className="mb-6 label-gray-700 text-sm"
              >
                Mật khẩu mới
              </CFormLabel>
              <CFormInput
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                style={{
                  background: "transparent",
                  color: "#fff",
                  borderColor: "#deaa4f",
                }}
                className="form-height-44 w-100"
              />
            </CCol>

            <CCol xs={12}>
              <CFormLabel
                style={{ color: "#deaa4f" }}
                className="mb-6 label-gray-700 text-sm"
              >
                Xác nhận mật khẩu
              </CFormLabel>
              <CFormInput
                type="password"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                style={{
                  background: "transparent",
                  color: "#fff",
                  borderColor: "#deaa4f",
                }}
                className="form-height-44 w-100"
              />
            </CCol>

            <CCol>
              <CLoadingButton
                onClick={onSubmit}
                className="w-100 rounded-3 mt-2"
                style={{
                  background: "rgb(105 86 38)",
                  border: "2px solid #d89239",
                }}
                loading={loading}
                disabled={loading}
              >
                Đổi mật khẩu
              </CLoadingButton>
            </CCol>
          </CRow>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ThayDoiMatKhau;
